import { SetSearchRadiusAction } from './searchRadius';

export function setSearchRadius(
  radius: string,
  didUserChange: boolean,
): SetSearchRadiusAction {
  return { type: 'SEARCH_RADIUS_SET', radius, didUserChange };
}
